module.exports = __webpack_public_path__ + "img/SKMJ_road2.509d660b.jpg";